module.exports = __webpack_public_path__ + "static/media/card5.2d790f97.png";